import _extends from "@babel/runtime/helpers/extends";
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import Toggle from '../toggle/toggle';
import _Symbol from './checkboxSymbol';
import { dataHooks } from './constants';
import TooltipOnEllipsis from '../tooltipOnEllipsis/tooltipOnEllipsis';
import classNames from 'classnames';
// import InfoIcon from '../infoIcon/infoIcon';

var Checkbox = function Checkbox(props) {
  var label = props.label,
    labelAfterSymbol = props.labelAfterSymbol,
    children = props.children,
    translateIfNeeded = props.translateIfNeeded,
    getClassName = props.getClassName,
    _props$type = props.type,
    type = _props$type === void 0 ? '' : _props$type;
  var _renderSymbol = function _renderSymbol() {
    return /*#__PURE__*/React.createElement("span", {
      className: "symbol symbol-checkbox"
    }, /*#__PURE__*/React.createElement(_Symbol, null));
  };
  var _renderLabel = function _renderLabel() {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('label', 'label-checkbox', type.toLowerCase()),
      key: "label"
    }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
      dataHook: dataHooks.checkboxText,
      maxLines: props.maxLines
    }, translateIfNeeded(label)));
  };
  return /*#__PURE__*/React.createElement(Toggle, _extends({}, props, {
    name: "checkbox",
    className: classNames(getClassName('control-checkbox'), props.vAlign === 'TOP' ? 'align-top' : 'align-center')
  }), !labelAfterSymbol && /*#__PURE__*/React.createElement(React.Fragment, null, label && _renderLabel()), _renderSymbol(), labelAfterSymbol && /*#__PURE__*/React.createElement(React.Fragment, null, label && _renderLabel()), children);
};
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  /** Text to be displayed next to the checkbox input */
  label: PropTypes.string,
  /** The text type of the label */
  type: PropTypes.oneOf(['T01', 'T02', 'T03', 'T04', 'T05', 'T06', 'T07', 'T08', 'T09', 'T10', 'T11', 'T12', 'T13', 'T14', 'T15', 'T16', 'T17', 'T18', 'T19', 'T20', 'T21']),
  /** If true, the label is rendered after the input */
  labelAfterSymbol: PropTypes.bool,
  /** The actual boolean value of the input */
  value: PropTypes.bool,
  /** Truncates label text at a specific number of lines */
  maxLines: PropTypes.number,
  /** The vertical alignment of the input relative to the label */
  vAlign: PropTypes.oneOf(['TOP', 'CENTER']),
  /** Renders an <InfoIcon/> */
  // infoIcon: PropTypes.object,

  /** Sets an `input-[name]` class name on the HTML `<input>` element */
  name: PropTypes.string,
  /** When set to true, prevents invocation of `onChange` & `onCheck` and applies disabled styles */
  disabled: PropTypes.bool,
  /** Sets checkbox as indeterminate */
  indeterminate: PropTypes.bool,
  /** Invokes with `true` when checkbox is checked or `false` when unchecked (not invoked in case `disabled` is `true`) */
  onChange: PropTypes.func,
  /** Invokes when checkbox is checked (not invoked in case `disabled` is `true`) */
  onCheck: PropTypes.func,
  /** A callback function to be called on mouseEnter event (invoked even if `disabled` is `true`) */
  onMouseEnter: PropTypes.func,
  /** A callback function to be called on mouseLeave event (invoked even if `disabled` is `true`) */
  onMouseLeave: PropTypes.func
};
Checkbox.defaultProps = {
  labelAfterSymbol: false,
  value: false,
  maxLines: 1,
  vAlign: 'CENTER',
  indeterminate: false
};
export default compose(Checkbox);